// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqPullUpBarSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqPullUpBarSvg(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M13.4998 0V1V2H18.4998H18.7359L18.9471 2.10557L22.9471 4.10557L23.8415 4.55279L22.9471 6.34164L22.0526 5.89443L18.2638 4H13.4998V14V15H11.4998V14V4H6.73591L2.94706 5.89443L2.05263 6.34164L1.1582 4.55279L2.05263 4.10557L6.05263 2.10557L6.26378 2H6.49984H11.4998V1V0H13.4998ZM11.4998 22V19H7.49984H6.49984V17H7.49984H17.4998H18.4998V19H17.4998H13.4998V22H15.4998H16.4998V24H15.4998H9.49984H8.49984V22H9.49984H11.4998Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqPullUpBarSvg;
